import { useIsReadOnlyMode } from "components/AnalysisRenderMode";

export default function WriteMode({ children }) {
    const isReadOnlyMode = useIsReadOnlyMode();

    if (isReadOnlyMode) {
        return null;
    }

    return (
        <>
            {children}
        </>
    );
}